import { dataStreamTypes } from '../types';
import api from './api'

const SUB_URL = '/evidences'

export const getEvidenceSummary = async (run_id: string, moa: string, indication: string) => {
  try {
    const response = await api.post(`${SUB_URL}/summary`, { run_id: run_id, moa: moa, indication: indication });
    return response.data
  } catch (error) {
    console.error('Error fetching evidence summary:', error);
  }
};

export const getEvidence = async (stream: dataStreamTypes, run_id: string, moa: string, indication: string) => {
  let segments = []
  switch (stream) {
    case dataStreamTypes.diffexpr:
      segments = ['diffexpr']
      break;
    case dataStreamTypes.otg:
      segments = ['bbprot']
      break;
    case dataStreamTypes.otp:
      segments = ['genassoc']
      break;
    case dataStreamTypes.miningNovelty:
      segments = ['txtmining', 'publications']
      break;
    case dataStreamTypes.miningOverall:
      segments = ['txtmining', 'publications']
      break;
  }
  try {
    let responses = []
    for (let i = 0; i < segments.length; i++) {
      const response = await api.post(`${SUB_URL}/details/${segments[i]}`, { run_id: run_id, moa: moa, indication: indication })
      responses.push(response.data)
    }
    return responses
  } catch (error) {
    console.error('Error fetching evidence:', error);
  }
};

export const getAbstract = async (pubmed_id) => {
  try {
    const response = await api.get(`${SUB_URL}/details/publications/${pubmed_id}`);
    return response.data
  } catch (error) {
    console.error('Error fetching abstract:', error);
  }
};

